import React from 'react';
/**
 * Inline SVG illustrations for each bonus — zero network requests, instant load.
 * Each is a small, themed illustration that visually represents the bonus.
 */
const baseProps = {
  viewBox: '0 0 120 120',
  xmlns: 'http://www.w3.org/2000/svg',
  className: 'w-full h-full',
  'aria-hidden': true as const
};
// 1. Planilla Inteligente de Control Financiero — Spreadsheet
export function IllustrationSpreadsheet() {
  return <svg {...baseProps} data-id="element-34">
      <rect x="20" y="20" width="80" height="80" rx="8" fill="#0A1F44" data-id="element-35" />
      <rect x="20" y="20" width="80" height="16" rx="8" fill="#10B981" data-id="element-36" />
      <rect x="20" y="28" width="80" height="8" fill="#10B981" data-id="element-37" />
      {/* Grid lines */}
      <line x1="46" y1="36" x2="46" y2="100" stroke="#1e3a5f" strokeWidth="1" data-id="element-38" />
      <line x1="72" y1="36" x2="72" y2="100" stroke="#1e3a5f" strokeWidth="1" data-id="element-39" />
      <line x1="20" y1="52" x2="100" y2="52" stroke="#1e3a5f" strokeWidth="1" data-id="element-40" />
      <line x1="20" y1="68" x2="100" y2="68" stroke="#1e3a5f" strokeWidth="1" data-id="element-41" />
      <line x1="20" y1="84" x2="100" y2="84" stroke="#1e3a5f" strokeWidth="1" data-id="element-42" />
      {/* Cell content */}
      <rect x="26" y="42" width="14" height="3" rx="1.5" fill="#64748b" data-id="element-43" />
      <rect x="52" y="42" width="14" height="3" rx="1.5" fill="#64748b" data-id="element-44" />
      <rect x="78" y="42" width="14" height="3" rx="1.5" fill="#64748b" data-id="element-45" />
      <rect x="26" y="58" width="14" height="3" rx="1.5" fill="#cbd5e1" data-id="element-46" />
      <rect x="52" y="58" width="14" height="3" rx="1.5" fill="#10B981" data-id="element-47" />
      <rect x="78" y="58" width="14" height="3" rx="1.5" fill="#10B981" data-id="element-48" />
      <rect x="26" y="74" width="14" height="3" rx="1.5" fill="#cbd5e1" data-id="element-49" />
      <rect x="52" y="74" width="14" height="3" rx="1.5" fill="#10B981" data-id="element-50" />
      <rect x="78" y="74" width="14" height="3" rx="1.5" fill="#10B981" data-id="element-51" />
      <rect x="26" y="90" width="14" height="3" rx="1.5" fill="#cbd5e1" data-id="element-52" />
      <rect x="52" y="90" width="14" height="3" rx="1.5" fill="#10B981" data-id="element-53" />
      <rect x="78" y="90" width="14" height="3" rx="1.5" fill="#10B981" data-id="element-54" />
    </svg>;
}
// 2. Desafío Ahorro 30 Días — Piggy bank with 30
export function IllustrationPiggyBank() {
  return <svg {...baseProps} data-id="element-55">
      <circle cx="60" cy="60" r="40" fill="#0A1F44" data-id="element-56" />
      {/* Piggy body */}
      <ellipse cx="60" cy="65" rx="28" ry="22" fill="#10B981" data-id="element-57" />
      {/* Ear */}
      <path d="M44 47 L42 38 L52 44 Z" fill="#059669" data-id="element-58" />
      {/* Eye */}
      <circle cx="50" cy="58" r="2.5" fill="white" data-id="element-59" />
      <circle cx="50" cy="58" r="1.2" fill="#0A1F44" data-id="element-60" />
      {/* Snout */}
      <ellipse cx="38" cy="65" rx="6" ry="5" fill="#059669" data-id="element-61" />
      <circle cx="36" cy="65" r="1" fill="#0A1F44" data-id="element-62" />
      <circle cx="40" cy="65" r="1" fill="#0A1F44" data-id="element-63" />
      {/* Slot */}
      <rect x="56" y="50" width="14" height="3" rx="1.5" fill="#0A1F44" data-id="element-64" />
      {/* Legs */}
      <rect x="48" y="82" width="5" height="6" fill="#059669" data-id="element-65" />
      <rect x="68" y="82" width="5" height="6" fill="#059669" data-id="element-66" />
      {/* Coin */}
      <circle cx="63" cy="40" r="6" fill="#fbbf24" stroke="#f59e0b" strokeWidth="1.5" data-id="element-67" />
      <text x="63" y="43" fontSize="7" textAnchor="middle" fill="#92400e" fontWeight="bold" data-id="element-68">
        $
      </text>
      {/* 30 days badge */}
      <circle cx="90" cy="35" r="12" fill="#fbbf24" data-id="element-69" />
      <text x="90" y="39" fontSize="11" textAnchor="middle" fill="#0A1F44" fontWeight="bold" data-id="element-70">
        30
      </text>
    </svg>;
}
// 3. 50 Formas Reales de Generar Ingresos Extra — Lightbulb with money
export function IllustrationLightbulb() {
  return <svg {...baseProps} data-id="element-71">
      <rect width="120" height="120" rx="12" fill="#0A1F44" data-id="element-72" />
      {/* Rays */}
      <g stroke="#fbbf24" strokeWidth="2.5" strokeLinecap="round" data-id="element-73">
        <line x1="60" y1="15" x2="60" y2="22" data-id="element-74" />
        <line x1="30" y1="30" x2="35" y2="35" data-id="element-75" />
        <line x1="90" y1="30" x2="85" y2="35" data-id="element-76" />
        <line x1="20" y1="55" x2="28" y2="55" data-id="element-77" />
        <line x1="100" y1="55" x2="92" y2="55" data-id="element-78" />
      </g>
      {/* Bulb */}
      <circle cx="60" cy="55" r="22" fill="#fbbf24" data-id="element-79" />
      <circle cx="55" cy="48" r="6" fill="#fde68a" opacity="0.7" data-id="element-80" />
      {/* Base */}
      <rect x="50" y="76" width="20" height="5" fill="#94a3b8" data-id="element-81" />
      <rect x="52" y="81" width="16" height="4" fill="#64748b" data-id="element-82" />
      <rect x="54" y="85" width="12" height="3" fill="#475569" data-id="element-83" />
      {/* $ inside */}
      <text x="60" y="62" fontSize="22" textAnchor="middle" fill="#92400e" fontWeight="bold" data-id="element-84">
        $
      </text>
      {/* Floating coins */}
      <circle cx="28" cy="85" r="5" fill="#10B981" data-id="element-85" />
      <text x="28" y="88" fontSize="6" textAnchor="middle" fill="white" fontWeight="bold" data-id="element-86">
        $
      </text>
      <circle cx="95" cy="90" r="6" fill="#10B981" data-id="element-87" />
      <text x="95" y="93" fontSize="7" textAnchor="middle" fill="white" fontWeight="bold" data-id="element-88">
        $
      </text>
      <circle cx="85" cy="105" r="4" fill="#10B981" data-id="element-89" />
    </svg>;
}
// 4. Guía Anti Deudas — Shield breaking chains
export function IllustrationShield() {
  return <svg {...baseProps} data-id="element-90">
      <rect width="120" height="120" rx="12" fill="#0A1F44" data-id="element-91" />
      {/* Shield */}
      <path d="M60 20 L88 30 L88 60 Q88 85 60 100 Q32 85 32 60 L32 30 Z" fill="#10B981" stroke="#059669" strokeWidth="2" data-id="element-92" />
      {/* Check */}
      <path d="M45 60 L55 70 L75 48" stroke="white" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" fill="none" data-id="element-93" />
      {/* Broken chain links */}
      <ellipse cx="22" cy="45" rx="5" ry="3" fill="none" stroke="#64748b" strokeWidth="2" data-id="element-94" />
      <ellipse cx="98" cy="75" rx="5" ry="3" fill="none" stroke="#64748b" strokeWidth="2" data-id="element-95" />
      {/* Red X mark for "deuda" */}
      <circle cx="22" cy="80" r="8" fill="#ef4444" data-id="element-96" />
      <line x1="18" y1="76" x2="26" y2="84" stroke="white" strokeWidth="2.5" strokeLinecap="round" data-id="element-97" />
      <line x1="26" y1="76" x2="18" y2="84" stroke="white" strokeWidth="2.5" strokeLinecap="round" data-id="element-98" />
    </svg>;
}
// 5. Checklist Semanal Financiero — Checklist with checkmarks
export function IllustrationChecklist() {
  return <svg {...baseProps} data-id="element-99">
      <rect width="120" height="120" rx="12" fill="#0A1F44" data-id="element-100" />
      {/* Clipboard */}
      <rect x="30" y="22" width="60" height="80" rx="6" fill="white" data-id="element-101" />
      <rect x="48" y="18" width="24" height="10" rx="3" fill="#94a3b8" data-id="element-102" />
      {/* Checklist rows */}
      <g data-id="element-103">
        <rect x="38" y="38" width="10" height="10" rx="2" fill="#10B981" data-id="element-104" />
        <path d="M40 43 L43 46 L47 41" stroke="white" strokeWidth="1.5" fill="none" strokeLinecap="round" data-id="element-105" />
        <rect x="52" y="42" width="32" height="3" rx="1.5" fill="#10B981" data-id="element-106" />
      </g>
      <g data-id="element-107">
        <rect x="38" y="54" width="10" height="10" rx="2" fill="#10B981" data-id="element-108" />
        <path d="M40 59 L43 62 L47 57" stroke="white" strokeWidth="1.5" fill="none" strokeLinecap="round" data-id="element-109" />
        <rect x="52" y="58" width="28" height="3" rx="1.5" fill="#10B981" data-id="element-110" />
      </g>
      <g data-id="element-111">
        <rect x="38" y="70" width="10" height="10" rx="2" fill="#10B981" data-id="element-112" />
        <path d="M40 75 L43 78 L47 73" stroke="white" strokeWidth="1.5" fill="none" strokeLinecap="round" data-id="element-113" />
        <rect x="52" y="74" width="30" height="3" rx="1.5" fill="#10B981" data-id="element-114" />
      </g>
      <g data-id="element-115">
        <rect x="38" y="86" width="10" height="10" rx="2" fill="none" stroke="#cbd5e1" strokeWidth="1.5" data-id="element-116" />
        <rect x="52" y="90" width="26" height="3" rx="1.5" fill="#cbd5e1" data-id="element-117" />
      </g>
    </svg>;
}
// 6. Manual para Dejar de Vivir Preocupado por el Dinero — Open book with zen
export function IllustrationZen() {
  return <svg {...baseProps} data-id="element-118">
      <rect width="120" height="120" rx="12" fill="#0A1F44" data-id="element-119" />
      {/* Open book */}
      <path d="M22 38 L60 30 L60 92 L22 100 Z" fill="white" data-id="element-120" />
      <path d="M98 38 L60 30 L60 92 L98 100 Z" fill="#e2e8f0" data-id="element-121" />
      <line x1="60" y1="30" x2="60" y2="92" stroke="#94a3b8" strokeWidth="1" data-id="element-122" />
      {/* Lines on pages */}
      <line x1="30" y1="48" x2="54" y2="44" stroke="#cbd5e1" strokeWidth="1.5" data-id="element-123" />
      <line x1="30" y1="56" x2="54" y2="52" stroke="#cbd5e1" strokeWidth="1.5" data-id="element-124" />
      <line x1="30" y1="64" x2="54" y2="60" stroke="#cbd5e1" strokeWidth="1.5" data-id="element-125" />
      <line x1="66" y1="44" x2="90" y2="48" stroke="#cbd5e1" strokeWidth="1.5" data-id="element-126" />
      <line x1="66" y1="52" x2="90" y2="56" stroke="#cbd5e1" strokeWidth="1.5" data-id="element-127" />
      {/* Smiley + heart */}
      <circle cx="60" cy="72" r="14" fill="#10B981" data-id="element-128" />
      <circle cx="55" cy="69" r="1.5" fill="white" data-id="element-129" />
      <circle cx="65" cy="69" r="1.5" fill="white" data-id="element-130" />
      <path d="M53 75 Q60 80 67 75" stroke="white" strokeWidth="2" fill="none" strokeLinecap="round" data-id="element-131" />
      {/* Sparkles */}
      <path d="M85 25 L87 30 L92 32 L87 34 L85 39 L83 34 L78 32 L83 30 Z" fill="#fbbf24" data-id="element-132" />
      <circle cx="30" cy="28" r="2" fill="#fbbf24" data-id="element-133" />
    </svg>;
}
// PRO 1 — Calendario Financiero de 12 Meses
export function IllustrationCalendar() {
  return <svg {...baseProps} data-id="element-134">
      <rect x="18" y="22" width="84" height="80" rx="8" fill="white" stroke="#0A1F44" strokeWidth="2" data-id="element-135" />
      <rect x="18" y="22" width="84" height="20" rx="8" fill="#0A1F44" data-id="element-136" />
      <rect x="18" y="34" width="84" height="8" fill="#0A1F44" data-id="element-137" />
      {/* Rings */}
      <rect x="32" y="14" width="4" height="14" rx="2" fill="#64748b" data-id="element-138" />
      <rect x="84" y="14" width="4" height="14" rx="2" fill="#64748b" data-id="element-139" />
      <text x="60" y="36" fontSize="9" textAnchor="middle" fill="white" fontWeight="bold" data-id="element-140">
        12 MESES
      </text>
      {/* Mini month grid */}
      {Array.from({
      length: 12
    }).map((_, i) => {
      const col = i % 4;
      const row = Math.floor(i / 4);
      const x = 26 + col * 18;
      const y = 50 + row * 16;
      const isHighlight = i === 5 || i === 10;
      return <g key={i} data-id="element-141">
            <rect x={x} y={y} width="14" height="12" rx="2" fill={isHighlight ? '#10B981' : '#f1f5f9'} data-id="element-142" />
            <text x={x + 7} y={y + 8} fontSize="6" textAnchor="middle" fill={isHighlight ? 'white' : '#0A1F44'} fontWeight="bold" data-id="element-143">
              {['E', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'][i]}
            </text>
          </g>;
    })}
    </svg>;
}
// PRO 2 — Planificador de Objetivos Económicos — Target with arrow
export function IllustrationTarget() {
  return <svg {...baseProps} data-id="element-144">
      <rect width="120" height="120" rx="12" fill="white" data-id="element-145" />
      {/* Target rings */}
      <circle cx="60" cy="60" r="44" fill="#0A1F44" data-id="element-146" />
      <circle cx="60" cy="60" r="34" fill="white" data-id="element-147" />
      <circle cx="60" cy="60" r="24" fill="#10B981" data-id="element-148" />
      <circle cx="60" cy="60" r="14" fill="white" data-id="element-149" />
      <circle cx="60" cy="60" r="6" fill="#ef4444" data-id="element-150" />
      {/* Arrow */}
      <line x1="20" y1="20" x2="60" y2="60" stroke="#0A1F44" strokeWidth="3" strokeLinecap="round" data-id="element-151" />
      <path d="M18 18 L26 22 L22 26 Z" fill="#0A1F44" data-id="element-152" />
      <path d="M58 58 L65 56 L65 65 Z" fill="#0A1F44" data-id="element-153" />
      {/* $ */}
      <text x="60" y="64" fontSize="8" textAnchor="middle" fill="white" fontWeight="bold" data-id="element-154">
        $
      </text>
    </svg>;
}
// PRO 3 — Sistema $100.000 Extra — Money stack with arrow up
export function IllustrationMoneyStack() {
  return <svg {...baseProps} data-id="element-155">
      <rect width="120" height="120" rx="12" fill="white" data-id="element-156" />
      {/* Money stacks - ascending */}
      <rect x="22" y="78" width="20" height="22" rx="2" fill="#10B981" stroke="#059669" strokeWidth="1.5" data-id="element-157" />
      <text x="32" y="92" fontSize="8" textAnchor="middle" fill="white" fontWeight="bold" data-id="element-158">
        $
      </text>
      <rect x="50" y="62" width="20" height="38" rx="2" fill="#10B981" stroke="#059669" strokeWidth="1.5" data-id="element-159" />
      <text x="60" y="84" fontSize="9" textAnchor="middle" fill="white" fontWeight="bold" data-id="element-160">
        $$
      </text>
      <rect x="78" y="42" width="20" height="58" rx="2" fill="#10B981" stroke="#059669" strokeWidth="1.5" data-id="element-161" />
      <text x="88" y="74" fontSize="9" textAnchor="middle" fill="white" fontWeight="bold" data-id="element-162">
        $$$
      </text>
      {/* Arrow up */}
      <path d="M20 50 Q50 30 95 25" stroke="#0A1F44" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeDasharray="3 3" data-id="element-163" />
      <path d="M95 25 L88 22 L92 32 Z" fill="#0A1F44" data-id="element-164" />
      {/* $100K label */}
      <rect x="35" y="18" width="42" height="16" rx="8" fill="#fbbf24" data-id="element-165" />
      <text x="56" y="30" fontSize="9" textAnchor="middle" fill="#0A1F44" fontWeight="bold" data-id="element-166">
        +$100K
      </text>
    </svg>;
}